import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VendorInviteForm } from 'src/app/classes/form-groups/vendor-invite-form';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-vendor-invite-modal',
  templateUrl: './vendor-invite-modal.component.html',
  styleUrl: './vendor-invite-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorInviteModalComponent implements OnInit {
  constructor(
    private ActiveModal: NgbActiveModal,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  @Input() CompanyId!: number;

  VendorInviteFormGroup = new VendorInviteForm();

  send() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.VendorInviteFormGroup
    );
    if (errors) {
      const { inviteEmail } = errors;
      if (inviteEmail) {
        const { required, emailPattern } = inviteEmail;
        if (required) {
          throw this.ToastService.addErrorToast(
            'Error',
            'You must enter an email address.',
            { returnError: true }
          );
        }
        if (emailPattern) {
          throw this.ToastService.addErrorToast(
            'Error',
            'You must enter a valid email address.',
            { returnError: true }
          );
        }
      }
    }

    const {
      controls: { InvitationContact },
      value: { inviteEmail }
    } = this.VendorInviteFormGroup;

    InvitationContact.patchValue({ email: inviteEmail });

    this.ActiveModal.close(this.VendorInviteFormGroup);
  }

  close() {
    this.ActiveModal.dismiss();
  }

  ngOnInit(): void {
    if (!this.CompanyId) {
      throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
        returnError: true
      });
    }

    this.VendorInviteFormGroup.patchValue({
      CompanyId: this.CompanyId,
      InvitationContact: {
        CompanyId: this.CompanyId
      }
    });
  }
}
